import {useParams} from 'react-router-dom';
import ApiInterface from "@/commons/api/ApiInterface";
import React, {useEffect} from "react";

import "./style.css";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import Redirect from "@/commons/utils/Components/Redirect";
import Redirects from "@/commons/utils/Redirects";
import BaseInfoBoxs from "@/commons/infoBox/BaseInfoBoxs";

const EmailConfirm = () => {
    let {token} = useParams();

    async function verifyEmail() {
        let text = (document.getElementById("emailVerifyText") as HTMLElement);

        ApiInterface.getToken(token).then(async (res) => {
            if (res.status !== 200) {
                if (res.status === 408) {
                    Redirects.domainSend("www", "profile", {popupData: BaseInfoBoxs("emailExpiredToken"), page: "settings"});
                } else {
                    Redirects.domainSend("www", "profile", {popupData: BaseInfoBoxs("emailInvalidToken"), page: "settings"});
                }
            }
            let result = await res.json();
            let scope = result["scope"];

            if (scope !== "EMAIL_VERIFICATION") {
                Redirects.domainSend("www", "profile", {popupData: BaseInfoBoxs("emailInvalidScope"), page: "settings"});
            }

            await ApiInterface.verifyEmail(token).then(async (verificationRes) => {
                if (verificationRes.status !== 200) {
                    Redirects.domainSend("www", "profile", {popupData: BaseInfoBoxs("emailInvalidToken"), page: "settings"});
                } else {
                    Redirects.domainSend("www", "profile", {popupData: BaseInfoBoxs("emailVerified")});
                }
            });
        });
    }

    useEffect(() => {
        verifyEmail();
    }, []);
    return (
        <>
            <div className={"page__body"}>
                <Header/>
                <div className={"page__content"}>
                    <div>
                        <h1>Verifica E-Mail</h1><br/><br/>
                        <div id={"emailVerifyText"}>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </>
    );
}

export default EmailConfirm;